import React from "react";
import AnimationRevealPage from "../../components/LandingPage/helpers/AnimationRevealPage.js";
import tabImg from "../../components/LandingPage/images/tabImg.png";
import poweredAI from "../../components/LandingPage/images/poweredAI.png";

import Home from "../Home.jsx";
import Footer from "../../components/Footer.js";
import Transform from "./Transform.js";
import StepsHome from "./StepsHome.jsx";
import GettingStarted from "./GettingStarted.jsx";
import Subscription from "./Subscription.jsx";
import Testimonials from "./Testimonials.jsx";
import FAQs from "./FAQs.jsx";
import FeatureRow from "./FeatureRow.jsx";
import { useLocation } from "react-router-dom";

export default () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const queryString = location.search;

  // Find the token using a regular expression
  const tokenMatch = queryString.match(/\/([^/]+)$/);

  return (
    <div
      className="flex flex-col"
      style={{
        background:
          "linear-gradient(289.62deg, rgba(166, 127, 170, 0.5) 3.2%, rgba(192, 255, 213, 0.5) 33.17%, rgba(165, 215, 252, 0.5) 49.39%, rgba(166, 127, 170, 0.5) 84.77%)",
      }}
    >
      <AnimationRevealPage>
        <Home />

        <div
          className="md:h-full h-auto px-2 lg:mt-[-100px] relative"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={tabImg} alt="Tab Image" />
        </div>
        <div className="md:pt-12 p-6">
          <FeatureRow />
        </div>
        <div className="p-6">
          <Transform />
        </div>
        <div className="md:p-20 p-6">
          <StepsHome />
        </div>
        <div className="p-6">
          <GettingStarted />
        </div>
        <div className=" p-6">
          <Subscription />
        </div>
        <div className="md:p-20 p-6">
          <Testimonials />
        </div>
        <div className="md:pt-20 pt-20 p-6">
          <FAQs />
        </div>

        <div
          className="h-auto pb-20"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={poweredAI} alt="Powered by OpenAI" />
        </div>
        <Footer />
      </AnimationRevealPage>
    </div>
  );
};
